import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import Badge from '../ui/Badge';

/** FIX-CLAUDE-B (D-314 §11) — the small "Claude" tag: this was done through Claude. OTE employees only. */
export default function ClaudeBadge({ className = '' }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <Badge tone="violet" className={className} title={t('claudeConnect.badgeTitle')}>
      <Sparkles size={10} aria-hidden="true" />
      {t('claudeConnect.badge')}
    </Badge>
  );
}
